import React from 'react';
import styles from './styles.module.scss';

export default function ContentTitle({ title }: { title: string }) {
    return <h4 className={styles.contentTitle}>{title}</h4>;
}
